{
  "title": "Conjure Lesser Demon (UA)",
  "source": "Unearthed Arcana 11 - That Old Black Magic",
  "levelAndSchool": "3rd-level conjuration",
  "level": 3,
  "castingTime": "1 action",
  "range": "60 feet",
  "components": "V, S, M (a vial of blood from an intelligent humanoid killed within the past 24 hours)",
  "duration": "Concentration, up to 1 hour",
  "description": [
    "You summon up to a total of eight manes or dretches that appear in unoccupied spaces you can see within range. A manes or dretch disappears when it drops to 0 hit points or when the spell ends.",
    "The demons are hostile to all creatures. Roll initiative for the summoned demons as a group, which has its own turns. The demons attack the nearest non-demons to the best of their ability.",
    "As part of casting the spell, you can scribe a circle on the ground with the blood used as a material component. The circle is large enough to encompass your space. The summoned demons cannot cross the circle or target anyone in it while the spell lasts. Using the material component in this manner consumes it.",
    "At Higher Levels. When you cast this spell using a spell slot of 6th or 7th level, you summon sixteen demons. If you cast it using a spell slot of 8th or 9th level, you summon thirty-two demons."
  ],
  "spellLists": ["sorcerer", "wizard"]
}
